import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react-lite';
import ScrollToTop from '../../../../../ScrollToTop';
import Loader from '../../../../Loader';
import DeepLinksBody from '../../DeepLinks/DeepLinksBody';
import InvitationsView from '../../Invitations/InvitationsView';
import Finishing from '../../CurrentCollectionStep/Finishing';
import Navigation from './Navigation';
import Preview from './Preview';
import Share from './Share';
import LoadError from '../../LoadError';
import Builder from './Builder';
import ChooseLearningDesign from './ChooseLearningDesign';
import Details from './Details';
import LearningCollectionEditStore from '../Store';
import FormSkeleton from './Details/FormSkeleton';

interface Props {
  store: LearningCollectionEditStore;
}

function CurrentCollectionStep({ store }: Props) {
  switch (store.state.kind) {
    case 'waiting':
    case 'loading':
    case 'ready':
      return <FormSkeleton />;
    case 'loading-for-deep-links':
    case 'loading-for-invitations':
      return <Loader />;
    case 'editing-details':
    case 'saving-details':
      return <Details store={store} state={store.state} />;
    case 'updating-product-license':
    case 'building':
    case 'adding-learning-design':
    case 'edit-form-submission-error':
      return <Builder store={store} state={store.state} />;
    case 'choosing-learning-designs':
      return <ChooseLearningDesign store={store} state={store.state} />;
    case 'previewing':
    case 'previewing-updating':
      return <Preview store={store} state={store.state} />;
    case 'sharing':
      return <Share store={store} state={store.state} />;
    case 'finishing':
    case 'finished':
      return <Finishing store={store} celebrate={store.state.celebrationPage} />;
    case 'load-error':
      return <LoadError />;
    case 'updating':
    case 'deleting-section':
      return (
        <>
          <ScrollToTop />
          <Navigation store={store} />
          <Loader />;
        </>
      );
    case 'ready-deep-links':
      return <DeepLinksBody learningCollectionStore={store} state={store.state} />;
    case 'ready-invitations':
      return (
        <InvitationsView learningCollectionResource={store.state.learningCollectionResource} />
      );
    default:
      assertNever(store.state);
  }
}

export default observer(CurrentCollectionStep);
